import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 1,
  class: "io-section__loader"
}

import {
  SectionPropsDefaults,
  SectionPropsInterface,
} from '@/data/Section';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import {
  computed,
  ref,
} from 'vue';
import IoWave from '@/components/IoWave.vue';
import { getRandomId } from '@/helpers';
import Observer from '@/components/Observer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Section',
  props: /*#__PURE__*/_mergeDefaults({
    anchorId: {},
    mediaId: {},
    mediaSizes: {},
    background: {},
    gradient: {},
    paddingTop: { type: Boolean },
    paddingBottom: { type: Boolean },
    wave: {},
    waveMirrored: { type: Boolean },
    waveNegative: { type: Boolean },
    wavePaddingPercentage: {},
    loading: { type: Boolean }
  }, SectionPropsDefaults),
  setup(__props: any) {

library.add(faSpinner);

const props = __props;

const waveId = getRandomId('wave-');

const maskStyles = computed(() => {
  let svgMaskUrl = '';

  if (props.wave !== 'none') {
    if (props.wave === 'wave') {
      if (props.waveNegative && !props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/WelleNegativ.webp`;
      } else if (props.waveNegative && props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/WelleNegativGespiegelt.webp`;
      } else if (!props.waveNegative && props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/WelleGespiegelt.webp`;
      } else {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/Welle.webp`;
      }
    } else if (props.wave === 'double-wave') {
      if (props.waveNegative && !props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/DoppelwelleNegativ.webp`;
      } else if (props.waveNegative && props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/DoppelwelleNegativGespiegelt.webp`;
      } else if (!props.waveNegative && props.waveMirrored) {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/DoppelwelleGespiegelt.webp`;
      } else {
        svgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/WelleDoppelt.webp`;
      }
    }
  }

  return {
    mask: `url(#${waveId}) top/auto no-repeat, linear-gradient(#fff 0 0)`,
    '-webkit-mask': `url(${svgMaskUrl}) top/auto no-repeat, linear-gradient(#fff 0 0)`,
    '-webkit-mask-composite': 'destination-out',
    'mask-composite': 'exclude',
    'mask-size': 'calc(100% + 6px) auto',
    'mask-position': 'center -3px, 0% 0%',
  };
});

const waveMarginBottom = computed<boolean>(() => {
  if (props.wave !== 'none') {
    if (props.wave === 'wave') {
      return (!props.waveNegative && props.waveMirrored)
        || (!props.waveNegative && !props.waveMirrored);
    }
  }

  return false;
});

const backgroundClasses = computed<string[]>(() => {
  const classes: string[] = [];

  classes.push(`bg-${props.background}`);

  if (props.gradient !== 'none') {
    classes.push(`gradient-${props.gradient}`);
  }

  return classes;
});

const section = ref();
const sectionStyles = ref<Record<string, string>>({});

const onWaveResize = ({ height }: Record<string, any>) => {
  sectionStyles.value.marginTop = `-${height || 0}px`;

  if (
    section.value
      && section.value.previousSibling
      && section.value.previousSibling.style !== undefined
      && props.wave !== 'none'
  ) {
    const percentageValue = parseInt(props.wavePaddingPercentage || '0', 10) / 100;

    section.value.previousSibling.style.setProperty('--wave-padding-bottom', `${height || 0}px`);
    section.value.previousSibling.style.setProperty('--wave-padding-bottom-percentage', percentageValue);
  } else if (
    section.value
      && section.value.previousSibling
      && section.value.previousSibling.style !== undefined
  ) {
    section.value.previousSibling.style.removeProperty('--wave-padding-bottom');
    section.value.previousSibling.style.removeProperty('--wave-padding-bottom-percentage');
  }
};

const sectionClass = computed<string[]>(() => {
  const sectionClasses: string[] = [];

  if (!props.paddingTop) {
    sectionClasses.push('pt-0');
  }

  if (!props.paddingBottom) {
    sectionClasses.push('pb-0');
  }

  if (props.wave !== 'none') {
    sectionClasses.push('has-wave');
  }

  if (props.loading) {
    sectionClasses.push('loading');
  }

  return sectionClasses;
});

return (_ctx: any,_cache: any) => {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["io-section", sectionClass.value]),
    style: _normalizeStyle(sectionStyles.value),
    ref_key: "section",
    ref: section
  }, [
    (props.wave !== 'none')
      ? (_openBlock(), _createBlock(Observer, {
          key: 0,
          class: _normalizeClass({ 'wave-bottom': waveMarginBottom.value }),
          onResize: onWaveResize
        }, {
          default: _withCtx(() => [
            _createVNode(IoWave, {
              "mask-id": _unref(waveId),
              class: "wave",
              "wave-type": props.wave,
              background: _ctx.background,
              "wave-mirrored": props.waveMirrored,
              "wave-negative": props.waveNegative
            }, null, 8, ["mask-id", "wave-type", "background", "wave-mirrored", "wave-negative"])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LazyBackgroundMedia, {
      class: _normalizeClass(["io-section__background", backgroundClasses.value]),
      "media-id": _ctx.mediaId,
      style: _normalizeStyle(maskStyles.value)
    }, null, 8, ["class", "media-id", "style"]),
    _createElementVNode("div", {
      id: _ctx.anchorId,
      class: "io-section__content"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FontAwesomeIcon, {
            icon: _unref(faSpinner),
            class: "fa-pulse"
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})